import { createContext } from 'react';
export var TakeUndoableMutationContext = createContext(function () { });
//# sourceMappingURL=TakeUndoableMutationContext.js.map